import { useState } from "react";
import { LIVE_ROOMS } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";

const FILTERS = ["全部", "热点", "八卦", "情感", "职场", "音乐", "萌宠"];

export default function LiveNow() {
  const [active, setActive] = useState("全部");
  const [follows, setFollows] = useState<Record<number, boolean>>({});

  const rooms = active === "全部" ? LIVE_ROOMS : LIVE_ROOMS.filter((r) => r.tag === active);

  return (
    <section id="live" className="relative scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            kicker="正在热播"
            title={
              <>
                你想要的吃瓜现场 <span className="text-primary-600">都在这里</span>
              </>
            }
            desc="高清连麦、实时弹幕、礼物打赏、精彩回放一站式在线。挑一个顺眼的直播间，点进去就是热闹现场。"
          />
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-2">
            {FILTERS.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setActive(f)}
                className={`rounded-full px-4 py-2 text-sm font-medium transition whitespace-nowrap ${
                  active === f
                    ? "bg-primary-500 text-foreground-950"
                    : "bg-secondary-100 text-foreground-700 hover:bg-secondary-200"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {rooms.map((room, idx) => (
            <Reveal key={room.id} delay={idx * 60}>
              <article className="group flex h-full flex-col overflow-hidden rounded-3xl border border-background-200 bg-background-100 transition hover:-translate-y-1 hover:border-primary-200">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={room.image}
                    alt={`${room.title}正在吃瓜快手直播，主播${room.host}`}
                    className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0"></div>
                  <span className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-red-500 px-2.5 py-1 text-xs font-semibold text-white">
                    <span className="live-dot inline-block h-1.5 w-1.5 rounded-full bg-white"></span>
                    直播中
                  </span>
                  <span className="absolute right-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
                    {room.badge}
                  </span>
                  <div className="absolute inset-x-3 bottom-3 flex items-center justify-between text-xs text-background-50">
                    <span className="inline-flex items-center gap-1 bg-black/30 px-2 py-1 rounded-md backdrop-blur">
                      <i className="ri-eye-line" /> {room.viewers} 人围观
                    </span>
                    <span className="inline-flex items-center gap-1 bg-black/30 px-2 py-1 rounded-md backdrop-blur">
                      <i className="ri-gift-2-fill text-accent-400" /> {room.gifts}
                    </span>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center gap-2">
                    <span className="rounded-full bg-secondary-200 px-2.5 py-0.5 text-xs font-medium text-foreground-700">
                      {room.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{room.host}</span>
                  </div>
                  <h3 className="mt-2.5 text-base md:text-lg font-bold leading-snug text-foreground-950">
                    {room.title}
                  </h3>
                  <div className="mt-4 flex items-center gap-2">
                    <a
                      href="#join"
                      className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-foreground-950 transition hover:bg-primary-600 whitespace-nowrap"
                    >
                      <i className="ri-play-fill text-base" /> 进房围观
                    </a>
                    <button
                      type="button"
                      aria-label="关注主播"
                      onClick={() => setFollows((p) => ({ ...p, [room.id]: !p[room.id] }))}
                      className={`flex h-10 w-10 items-center justify-center rounded-full border text-base transition whitespace-nowrap ${
                        follows[room.id]
                          ? "border-accent-300 bg-accent-100 text-accent-800"
                          : "border-secondary-300 text-foreground-600 hover:bg-secondary-100"
                      }`}
                    >
                      <i className={follows[room.id] ? "ri-star-fill" : "ri-star-line"} />
                    </button>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}